import DirectoryPeriods from "../classes/DirectoryPeriods";

const state = {
  data: [],
  set: false
};

const getters = {};

const actions = {
  directory_periods_list(state, data) {
    state.commit("setData", data);
  }
};

const mutations = {
  setData(state, data) {
    state.data = DirectoryPeriods.getSelfList(data);
    state.set = true;
  },
  addFirst(state) {
    state.data.unshift(new DirectoryPeriods());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
